import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'bar-line-chart',
    name: 'Bar/Line Chart',
    description: 'A chart with multiple lines or bars. Multiple data sources and 2 Y-Axis\'s can be configured. Visually data is represented as either a line, area chart, or stacked bars. The widget can be configured to refresh automatically at regular intervals.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-bar-line-chart" */ "./BarLineChartTemplate")),
    icon: generateIconProp('chartBar'),
    canDragDropFields: true,
    complexity: 'advanced',
    preLoader: 'bar-chart',
    expectedSchema: 'dictionary-array'
});
